import { QueryClient } from "@tanstack/react-query";

let sharedClient: QueryClient | null = null;

/** Shared defaults for Soft Deep server-state (soft-api). */
export function createSoftQueryClient(): QueryClient {
  if (!sharedClient) {
    sharedClient = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 30_000,
          retry: 1,
          refetchOnWindowFocus: false,
        },
      },
    });
  }
  return sharedClient;
}

/** Imperative invalidation from non-React modules. */
export function getSoftQueryClient(): QueryClient {
  return createSoftQueryClient();
}
